import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from '../../hooks/useWindowDimensions';
import { DATE_TIME_FORMAT_SHORT } from '../../utils/constants/domain-constants';

interface Props {
    updatedOn?: string;
    isPromoVisible: boolean;
}

const UpdateOn = (props: Props) => {
    const { t } = useTranslation();
    const { width } = useWindowDimensions();

    return (
        <div
            className="rl-update-on"
            style={{ width: props.isPromoVisible ? width / 2 : '100%' }}
            title={moment(props.updatedOn).format(DATE_TIME_FORMAT_SHORT)}
        >
            {t('UpdateOn.lastUpdate')} {moment(props.updatedOn).fromNow()}
        </div>
    );
};

export default UpdateOn;
